import { ROUTES } from '../utils/constants/enum'

export interface NavItem {
    label: string
    link?: string
    key: string
}

export interface Nav extends NavItem {
    note?: string
    rewardAppLaunch?: Boolean
    Menu?: Array<NavItem>
}

export const DASHBOARD = {
    label: 'manage_providers_page.dashboard_back_text',
    link: ROUTES.DASHBOARD,
    key: 'dashboard',
}

export const ACCOUNT_SETTINGS = {
    label: 'provider_dashboard_page.account_settings_text',
    link: ROUTES.ACCOUNT_SETTINGS,
    key: 'account settings',
}

export const CLIENT_REWARDS = {
    label: 'provider_dashboard_page.client_rewards_text',
    link: ROUTES.CLIENT_REWARDS,
    key: 'client rewards',
}

export const SYNDEO_REPORTS = {
    label: 'provider_dashboard_page.syndeo_reports_text',
    link: ROUTES.SYNDEO_REPORTS,
    key: 'syndeo reports',
}

export const TREATMENT_HISTORY = {
    label: 'client_dashboard_page.tx_history_text',
    link: ROUTES.TREATMENT,
    key: 'treatment history',
}

export const REWARDS = {
    label: 'client_dashboard_page.rewards_text',
    link: ROUTES.REWARDS_PAGE,
    key: 'rewards page',
}

export const HYDRAFACIALISTS = {
    label: 'provider_dashboard_page.manage_hydrafacialists_text',
    link: ROUTES.HYDRAFACIALISTS,
    key: 'hydrafacialists',
}

export const PROVIDERS = {
    label: 'esti_dashboard_page.manage_providers_text',
    link: ROUTES.PROVIDER,
    key: 'providers',
}

export const STORE = {
    label: 'provider_dashboard_page.store_text',
    link: ROUTES.STORE_TAB,
    key: 'store',
}

export const THE_DROP = {
    label: 'esti_dashboard_page.the_drop_text',
    link: ROUTES.THE_DROP,
    key: 'the drop',
}

export const SIDEBAR_NAV: Array<Nav> = [
    DASHBOARD,
    ACCOUNT_SETTINGS,
    SYNDEO_REPORTS,
    CLIENT_REWARDS,
    HYDRAFACIALISTS,
    STORE,
    THE_DROP,
]

export const ESTHETICIAN_SIDEBAR_NAV: Array<Nav> = [
    DASHBOARD,
    ACCOUNT_SETTINGS,
    SYNDEO_REPORTS,
    CLIENT_REWARDS,
    PROVIDERS,
    STORE,
    THE_DROP,
]

export const CLIENT_SIDEBAR_NAV: Array<Nav> = [
    DASHBOARD,
    ACCOUNT_SETTINGS,
    TREATMENT_HISTORY,
    REWARDS,
]

export const NO_SYNDEO_DASHBOARD: Array<string> = [
    ROUTES.DASHBOARD,
    ROUTES.ACCOUNT_DELETE,
]
